export const SVG_SIZE_S = 16;
export const SVG_SIZE_M = 20;
export const SVG_SIZE_L = 24;
export const SVG_SIZE_XL = 32;
export const SVG_SIZE_XXL = 40;
export const SVG_SIZE_XXXL = 64;
export const SVG_SIZE_XXXXL = 160;
